import React from "react"
import ReactDOM from "react-dom"
import LinkTiles from "./link-tiles-component"

export default class LinkTilesModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<LinkTiles {...self.modelJson} />, self.elem)
  }
}
